import script from "./block-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./block-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./block-wrap.vue?vue&type=style&index=0&id=30b36854&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b36854"]])

export default __exports__